module.exports = __webpack_public_path__ + "static/media/lon_haz_lev.e7cc3696.png";